import { client } from "../../hooks/Client"
import { useFirestoreGeneralOrderBy, useFirestoreGeneral} from "../../firebase/useFirestore"
import { useHistory } from "react-router-dom";
import ScrollToTop from "../../hooks/ScrollToTop";
import { db } from "../../firebase/config";
import useSettings from "../../hooks/Settings";
import NextStepContainer from "../../components/common/NextStepContainer.jsx";
import { Auth } from '../../StateManagment/Auth';
import { useContext, useState, useEffect } from "react";
import { SavedIcon } from "../../StateManagment/SavedIcon";
import { v4 as uuid } from 'uuid';
import { timestamp } from "../../firebase/config";
import RandomColorGenerator from "../../hooks/RandomColorGenerator";
import PreviousStepContainer from "../../components/common/PreviousStepContainer";
import OutputIsSyncedTitle from "../../components/syncronisations/OutputIsSyncedTitle";
import OutputIsSyncedDelete from "../../components/syncronisations/OutputIsSyncedDelete";
import PageHeader from "../../components/layout/PageHeader.jsx";
import SavedNotice from "../../components/common/SavedNotice"
import { DeccaContext } from "../../StateManagment/DeccaContext.js";
import Location from "../../hooks/Location"
import DragIconTableData from "../../components/common/DragIconTableData.jsx";
import DeleteModal from "../../components/common/DeleteModal";
import Tooltip from "../../components/common/Tooltip";
import Modal from 'react-modal';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import DragIndicatorOutlinedIcon from '@mui/icons-material/DragIndicatorOutlined';
import Table from "../../components/common/table/Table.jsx";
import ReadOnlyGuard from "../../components/common/ReadOnlyGuard";

const SubTargetgroups = () => {
   // Context
    const [saved, setSaved] = useContext(SavedIcon)
    const [auth] = useContext(Auth)

    // States
    const [dragArray, setDragArray] = useState([]);
    const [targetgroupTitle, setTargetgroupTitle] = useState('')
    const [deleteModal, setDeleteModal] = useState(false);
    const [deleteDocid, setDeleteDocid] = useState('');
    const [deleteName, setDeleteName] = useState('');
        
    // Hooks
    const history = useHistory()
    ScrollToTop()
    const randomColor = RandomColorGenerator()
    const targetgroupID = Location()[3]

    // Firestore
    const subTargetgroups = useFirestoreGeneralOrderBy('SubTargetgroups', 'TargetgroupID', targetgroupID || "", 'Position', 'asc')
    const targetgroups = useFirestoreGeneral('Stakeholders', 'ID', targetgroupID || "")

    // Modal settings
      Modal.setAppElement('#root');
      const modalStyles = {
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
        },
      };

    // Set targetgroup title
    useEffect(() => {
        if (targetgroups && targetgroups.length > 0) {
            setTargetgroupTitle(targetgroups[0].Organisation);
        }
    }, [targetgroups]);

    // Whenever Firestore data changes, update dragArray state
    useEffect(() => {
        setDragArray(subTargetgroups);
    }, [subTargetgroups]);

    // DRAG & DROP: reorder items and update Firestore
    const handleDragEnd = (result) => {
        if (!result.destination) return;
    
        const items = Array.from(dragArray);
        const [movedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, movedItem);
    
        // Update local state to reflect the reorder immediately
        setDragArray(items);
    
        // Now update Firestore with new positions
        items.forEach((item, idx) => {
          db.collection('SubTargetgroups')
            .doc(item.docid)
            .update({ Position: idx + 1 });
        });
    
        // Show "saved" icon
        setSaved('flex');
      };

    // Add sub targetgroup
    const addSubTargetgroup = (e) => {

        db.collection('SubTargetgroups')
        .doc()
        .set({
            ID: uuid(),
            Compagny: client,
            CompagnyID: client,
            Timestamp: timestamp,
            Title: 'Nieuwe subdoelgroep',
            Description: '',
            Position: subTargetgroups.length + 1,
            Color: randomColor,
            TargetgroupID: targetgroupID
        })
    }

    // Title handler
    const titleHandler = (e) => {
        const docid = e.target.dataset.docid
        const title = e.target.value

        db.collection('SubTargetgroups')
        .doc(docid)
        .update({
            Title: title
        })
        .then(() =>{
            setSaved(true)
        })
    }

    // Description handler
    const descriptionHandler = (e) => {
        const docid = e.target.dataset.docid
        const description = e.target.value

        db.collection('SubTargetgroups')
        .doc(docid)
        .update({
            Description: description
        })
        .then(() => {
            setSaved('flex')
        })
    }

    // Opens the delete modal
  const deleteModalHandler = (e) => {
    const docid = e.currentTarget.dataset.docid;
    const delName = e.currentTarget.dataset.deletename;

    setDeleteDocid(docid);
    setDeleteName(delName);
    setDeleteModal(true);
  };

  // Actually deletes one sub targetgroup doc
  const deleteSubTargetgroup = () => {
    db.collection('SubTargetgroups')
      .doc(deleteDocid)
      .delete()
      .then(() => {
        setDeleteModal(false);
        setSaved('flex');
      });
  };

  const tableColumns = [
    { key: 'drag', label: '', searchable: false },
    { key: 'title', label: 'SUB-DOELGROEP' },
    { key: 'description', label: 'BESCHRIJVING', searchable: false },
    { key: 'delete', label: 'VERWIJDEREN', searchable: false },
  ];

  return (
    <div className="main">
        <div className="main-container" >
            <PageHeader 
                heading={'Subdoelgroepen'}
                subHeading={`${targetgroupTitle}`}
                description={`In deze stap ga je de subdoelgroepen benoemen die vallen onder de doelgroep: ${targetgroupTitle}.`}
                AI={false}
            />
            <ReadOnlyGuard edit="strategy.edit">
                {(canEdit) => (
                    <Table
                        columns={tableColumns}
                        items={dragArray || []}
                        getItemKey={(subTargetgroup) => subTargetgroup.ID}
                        renderRow={(subTargetgroup) => (
                            <>
                                <td>
                                    <DragIndicatorOutlinedIcon />
                                </td>
                                <td>
                                    <input type="text" defaultValue={subTargetgroup.Title} data-docid={subTargetgroup.docid} onChange={titleHandler} />
                                </td>
                                <td className="common-table__cell--description">
                                    <Tooltip content={subTargetgroup.Description || ''} width="80%" top="-60px">
                                        <textarea
                                            className="common-table__description-textarea"
                                            data-docid={subTargetgroup.docid}
                                            defaultValue={subTargetgroup.Description || ''}
                                            placeholder="Beschrijving"
                                            onChange={descriptionHandler}
                                        />
                                    </Tooltip>
                                </td>
                                <td>
                                    {canEdit && (
                                        <DeleteOutlinedIcon
                                          className='table-delete-icon'
                                          data-docid={subTargetgroup.docid}
                                          data-deletename={subTargetgroup.Title}
                                          onClick={deleteModalHandler}
                                        />
                                    )}
                                </td>
                            </>
                        )}
                        searchAccessor={(subTargetgroup) => subTargetgroup.Title}
                        searchPlaceholder="Zoeken op sub-doelgroep"
                        emptyMessage="Geen sub-doelgroepen gevonden."
                        draggable={true}
                        droppableId="subtargetgroups"
                        onDragEnd={handleDragEnd}
                        addRow={canEdit ? {
                            toolTipContent: 'Sub-doelgroep toevoegen',
                            onClick: addSubTargetgroup,
                        } : undefined}
                    />
                )}
            </ReadOnlyGuard>
            <div className="impactstrategy-saved-and-nextstep-container">
                <SavedNotice />
                <div id='next-step-container'>
                    <PreviousStepContainer url={'stakeholders'} mainItem={'Doelgroepen'}/>
                    <NextStepContainer url={'Activities'} mainItem={'impactstrategy'}/>
                </div>
            </div>
        </div>
        {/* Delete modal */}
        <DeleteModal
          deleteModal={deleteModal}
          setDeleteModal={setDeleteModal}
          deleteItem={deleteSubTargetgroup}
          deleteName={deleteName}
        />
    </div>
  )
}

export default SubTargetgroups
